import * as Sentry from '@sentry/react';

import { SENTRY_APPLICATION_KEY } from './constants';

/**
 * Starts Sentry in a built bundle whose environment turns it on. A dev server never reports, whatever
 * its env file says: the E2E workflow runs one with the deployed env, and its axe output and React
 * dev warnings would land in Sentry as staging errors.
 */
export const initSentry = () => {
  if (!import.meta.env.PROD || import.meta.env.VITE_SENTRY_ENABLED !== 'true') return;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
      }),
      // handled: false keeps console errors arriving as unhandled, which is what the alerting and
      // issue grouping already assume. The SDK flipped this default, so dropping it silently
      // reclassifies every console error we report.
      Sentry.captureConsoleIntegration({ levels: ['error'], handled: false }),
      Sentry.httpClientIntegration(),
      // Injected scripts (in-app browsers, extensions) have no frame from our build.
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: [SENTRY_APPLICATION_KEY],
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
        // Sentry's own wrapper around timers and listeners is in our build; without this, an injected
        // callback run through it would count as ours.
        ignoreSentryInternalFrames: true,
      }),
    ],
    sendDefaultPii: true,
    replaysSessionSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAY_SESSION_RATE),
    replaysOnErrorSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAY_ERROR_SESSION_RATE),
    release: `${import.meta.env.VITE_NAME}@${import.meta.env.VITE_VERSION}`,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  });
};
